import { Link } from 'react-router-dom';
export default function NotFound() {
 return <main className="pt-40 pb-24 px-5 text-center"><h1 className="text-4xl font-bold text-royal-deep">Page not found</h1><p className="my-6">This page may have moved or the address may be incorrect.</p><Link className="text-royal underline" to="/">Return to GrowMyRestro</Link></main>;
}
